import axios, { AxiosError } from "axios";
import { useMutation, UseMutationResult } from "react-query";

// Request interfaces following architecture patterns
export interface AnalyticsIdentifyRequest {
  userId: string;
  traits?: Record<string, any>;
}

export interface AnalyticsTrackRequest {
  event: string;
  properties?: Record<string, any>;
}

export interface AnalyticsPageRequest {
  name?: string;
  properties?: Record<string, any>;
}

// Response interface
export interface AnalyticsResponse {
  success: boolean;
}

// Service functions following architecture patterns
const AnalyticsIdentifyApiService = async (
  request: AnalyticsIdentifyRequest
): Promise<AnalyticsResponse> => {
  const { data } = await axios.post("/analytics/identify", request);
  return data;
};

const AnalyticsTrackApiService = async (
  request: AnalyticsTrackRequest
): Promise<AnalyticsResponse> => {
  const { data } = await axios.post("/analytics/track", request);
  return data;
};

const AnalyticsPageApiService = async (
  request: AnalyticsPageRequest
): Promise<AnalyticsResponse> => {
  const { data } = await axios.post("/analytics/page", request);
  return data;
};

// React Query hooks following architecture patterns
export const useAnalyticsIdentifyApiService = (): UseMutationResult<
  AnalyticsResponse,
  AxiosError,
  AnalyticsIdentifyRequest
> =>
  useMutation<AnalyticsResponse, AxiosError, AnalyticsIdentifyRequest>(
    AnalyticsIdentifyApiService,
    {
      mutationKey: "AnalyticsIdentifyApiService",
    }
  );

export const useAnalyticsTrackApiService = (): UseMutationResult<
  AnalyticsResponse,
  AxiosError,
  AnalyticsTrackRequest
> =>
  useMutation<AnalyticsResponse, AxiosError, AnalyticsTrackRequest>(
    AnalyticsTrackApiService,
    {
      mutationKey: "AnalyticsTrackApiService",
    }
  );

export const useAnalyticsPageApiService = (): UseMutationResult<
  AnalyticsResponse,
  AxiosError,
  AnalyticsPageRequest
> =>
  useMutation<AnalyticsResponse, AxiosError, AnalyticsPageRequest>(
    AnalyticsPageApiService,
    {
      mutationKey: "AnalyticsPageApiService",
    }
  );
